import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const SUPABASE_URL = supabaseUrl
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Funções helper para operações comuns
export const produtosAPI = {
  // Obter todos os produtos
  getAll: async () => {
    const { data, error } = await supabase
      .from('Produtos')
      .select('Nome, Stock_Atual, Vendas_Mensais, Encomenda_Curso, Objetivo_Cobertura, Lead_Time, EAN, Data_Contagem, Data_Rececao, Email_Cliente')
    
    if (error) {
      console.error('Erro ao carregar produtos:', error)
      throw error
    }
    
    return data
  },

  // Obter produto por Nome (chave única)
  getById: async (nome) => {
    const { data, error } = await supabase
      .from('Produtos')
      .select('Nome, Stock_Atual, Vendas_Mensais, Encomenda_Curso, Objetivo_Cobertura, Lead_Time, EAN, Data_Contagem, Data_Rececao, Email_Cliente')
      .eq('Nome', nome)
      .single()
    
    if (error) {
      console.error('Erro ao carregar produto:', error)
      throw error
    }
    
    return data
  },

  // Criar novo produto
  create: async (produto) => {
    const { data, error } = await supabase
      .from('Produtos')
      .insert([produto])
      .select('Nome, Stock_Atual, Vendas_Mensais, Encomenda_Curso, Objetivo_Cobertura, Lead_Time, EAN, Data_Contagem, Data_Rececao, Email_Cliente')
    
    if (error) {
      console.error('Erro ao criar produto:', error)
      throw error
    }
    
    return data[0]
  },

  // Atualizar produto
  update: async (nome, produto) => {
    const { data, error } = await supabase
      .from('Produtos')
      .update(produto)
      .eq('Nome', nome)
      .select('Nome, Stock_Atual, Vendas_Mensais, Encomenda_Curso, Objetivo_Cobertura, Lead_Time, EAN, Data_Contagem, Data_Rececao, Email_Cliente')
    
    if (error) {
      console.error('Erro ao atualizar produto:', error)
      throw error
    }
    
    return data[0]
  },

  // Eliminar produto
  delete: async (nome) => {
    const { error } = await supabase
      .from('Produtos')
      .delete()
      .eq('Nome', nome)
    
    if (error) {
      console.error('Erro ao eliminar produto:', error)
      throw error
    }
    
    return true
  },

  // Obter histórico de stock (se existir)
  getHistorico: async (produtoNome) => {
    const { data, error } = await supabase
      .from('Historico_Stock')
      .select('*')
      .eq('produto_nome', produtoNome)
      .order('data', { ascending: false })
    
    if (error) {
      console.error('Erro ao carregar histórico:', error)
      throw error
    }
    
    return data
  }
}

export default supabase
